<template>
  <v-card flat>
    <div class="us-chat-msg" @click="clickPage">
      <div ref="list" class="message-wrapper">
          <ul v-if="chatDataList && !loading" style="padding-top:1rem;">
            <li v-for="(item,index) in chatDataList" :key="index" class="us-msg-item">
              <!-- <div class="time" v-if="showTime(item,index)" ><span>{{ getMsgTimeFormat(item.DR_TIME) }}</span></div> -->
              <div v-if="item.DR_TYPE === 2" class="main" :class="{ self: item.DR_USER_CODE === selfInfo.usercode }">
                <img class="avatar" width="36" height="36" :src="item.from_user.img">
                <div style="margin-left:61px;margin-bottom:5px;font-size:0.75rem;color:#9e9e9e;" v-if="item.DR_USER_CODE === selfInfo.usercode">
                  <span style="font-size:0.68rem;margin-right:0.5rem;" v-if="showTime(item,index)">{{ getMsgTimeFormat(item.DR_TIME) }}</span>
                  {{ item.from_user.name }}
                </div>
                <div style="margin-left:61px;margin-bottom:5px;font-size:0.75rem;color:#9e9e9e;" v-else>
                  {{ item.from_user.name }}
                  <span style="font-size:0.68rem;margin-left:0.5rem;" v-if="showTime(item,index)">{{ getMsgTimeFormat(item.DR_TIME) }}</span>
                </div>
                <div class="content">
                  <div v-html="replaceFace(item.DR_CONTENT)" />
                </div>
              </div>
              <div v-else>
                <div class="time" v-if="showTime(item,index)" ><span>{{ getMsgTimeFormat(item.DR_TIME) }}</span></div>
                <div class="us-op-content">
                  <div v-if="startsWith(item.DR_CONTENT,'修改了标题')">
                    <div style="margin-bottom:5px;"><span style="display:line-block;padding-right:8px;">{{ item.from_user.name }}</span>修改了标题</div>
                    <div style="padding-top:10px;font-size:13px;border-top:1px solid #f5f5f5;line-height:19px;">{{ item.DR_CONTENT.substring(5) }}</div>
                  </div>
                  <div v-else-if="startsWith(item.DR_CONTENT,'修改了内容')">
                    <div style="margin-bottom:5px;"><span style="display:line-block;padding-right:8px;">{{ item.from_user.name }}</span>修改了内容</div>
                    <div style="padding-top:10px;font-size:13px;border-top:1px solid #f5f5f5;line-height:19px;">{{ item.DR_CONTENT.substring(5) }}</div>
                  </div>
                  <div v-else-if="startsWith(item.DR_CONTENT,'修改了备注')">
                    <div style="margin-bottom:5px;"><span style="display:line-block;padding-right:8px;">{{ item.from_user.name }}</span>修改了备注</div>
                    <div style="padding-top:10px;font-size:13px;border-top:1px solid #f5f5f5;line-height:19px;">{{ item.DR_CONTENT.substring(5) }}</div>
                  </div>
                  <div v-else-if="startsWith(item.DR_CONTENT,'修改优先级')">
                    <div><span style="display:line-block;padding-right:8px;">{{ item.from_user.name }}</span>修改优先级为
                      <span v-if="item.DR_CONTENT.substring(6) === '较低'" style="color:#909399;">较低</span>
                      <span v-else-if="item.DR_CONTENT.substring(6) === '紧急'" style="color:#FF9900;">紧急</span>
                      <span v-else-if="item.DR_CONTENT.substring(6) === '非常紧急'" style="color:#F56C6C;">非常紧急</span>
                      <span v-else style="color:#409EFF;">一般</span>
                    </div>
                  </div>
                  <div v-else-if="startsWith(item.DR_CONTENT,'更改状态')">
                    <div><span style="display:line-block;padding-right:8px;">{{ item.from_user.name }}</span>更改状态为
                      <span v-if="item.DR_CONTENT.substring(5) === '处理中'" style="color:#FB8C00;">处理中</span>
                      <span v-else-if="item.DR_CONTENT.substring(5) === '已完成'" style="color:#67C23A;">已完成</span>
                      <span v-else style="color:#F56C6C;">待处理</span>
                    </div>
                  </div>
                  <!-- <div v-else-if="startsWith(item.DR_CONTENT,'修改故障时间为')">
                    <div>
                      <span style="display:line-block;padding-right:8px;">{{ self.name }}</span>
                      {{ item.DR_CONTENT }}
                    </div>
                  </div> -->
                  <div v-else>
                    <span style="display:line-block;padding-right:8px;">{{ item.from_user.name }}</span>
                    {{ item.DR_CONTENT }}
                  </div>
                </div>
              </div>

            </li>
          </ul>
          <div v-if="chatDataList.length === 0 && !loading" style="color:#9e9e9e;font-size:0.85rem;text-align:center;margin-top:3rem;">暂无动态</div>
          <div v-if="loading" style="margin-top:4rem;">
            <LoadingText />
          </div>
      </div>
      <div class="chat-footer" v-if="false" >
        <div class="emoji">
          <span><i class="fa fa-smile-o icon-look" aria-hidden="true" @click.stop="showEmoji=!showEmoji" /></span>
          <!-- <span style="margin-left:10px;"><i class="fa fa-folder-o icon-look" aria-hidden="true" /></span> -->
          <transition name="showbox">
            <div v-show="showEmoji" class="emojiBox">
              <li v-for="(item, index) in emojis" :key="index">
                <img :src="'/res/emoji/'+item.file" :data="item.code" @click="send_content += item.code">
              </li>
            </div>
          </transition>
        </div>
        <v-textarea auto-grow ref="text" rows="1" v-model="send_content" @keyup="onKeyup" />
        <div class="send">
          <!-- <span>发送(ent)</span> -->
          <div style="position:relative;height:40px;width:100%;">
            <v-btn color="#5cbbf6" style="position: absolute;bottom:12.5px;right:15px;color:#fff;" @click="sendMsg" depressed>发送(ent)</v-btn>
          </div>
        </div>
        <transition name="appear">
          <div v-show="warn" class="warn">
            <div class="description">不能发送空白信息</div>
          </div>
        </transition>
      </div>
      <v-bottom-navigation fixed v-if="showInput" grow style="padding:0 1rem;" >
        <v-row>
          <v-col :cols="9" style="padding:0;">
            <v-textarea class="mx-2" style="padding-top:0;margin-top:0.55rem;padding-left:0.5rem;" prepend-icon="fa fa-pencil" ref="text" rows="1" v-model="send_content" @keyup="onKeyup" />
          </v-col>
          <v-col :cols="3" style="padding:0;text-align:right;padding-right:1rem;">
            <!-- <i class="fa fa-paper-plane" aria-hidden="true" style="font-size:1.3rem;margin-top:1rem;color:#9e9e9e;"></i> -->
            <v-btn color="#5cbbf6" small style="margin-top:0.82rem;width:80%;border-radius:0.2rem;" @click="sendMsg">
              <span style="color:#fff;">发送</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-bottom-navigation>
    </div>
  </v-card>
</template>

<script>
import LoadingText from '../components/LoadingText'
const now = new Date()
export default {
  components: {
    LoadingText
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time(date) {
      var retText = ''
      if (typeof date === 'string') {
        date = new Date(date)
      }
      if (date.getMinutes() < 10) {
        retText = date.getHours() + ':0' + date.getMinutes()
      } else {
        retText = date.getHours() + ':' + date.getMinutes()
      }
      return retText
    }
  },
  props: {
    width: {
      type: String,
      default: '770px'
    },
    height: {
      type: String,
      default: '420px'
    },
    title: {
      type: String,
      default: '标题'
    },
    visible: {
      type: Boolean,
      default: false
    },
    orderCode: {
      type: String,
      default: ''
    },
    showInput: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      self: {
        name: 'others',
        img: '/res/chat/kf.jpg'
      },
      chatDataList: [],
      emojis: [
        { file: '100.gif', code: '/::)', title: '微笑', reg: /\/::\)/g },
        { file: '101.gif', code: '/::~', title: '伤心', reg: /\/::~/g },
        { file: '102.gif', code: '/::B', title: '美女', reg: /\/::B/g },
        { file: '103.gif', code: '/::|', title: '发呆', reg: /\/::\|/g },
        { file: '104.gif', code: '/:8-)', title: '墨镜', reg: /\/:8-\)/g },
        { file: '105.gif', code: '/::<', title: '哭', reg: /\/::</g },
        { file: '106.gif', code: '/::$', title: '羞', reg: /\/::\$/g },
        { file: '107.gif', code: '/::X', title: '哑', reg: /\/::X/g },
        { file: '108.gif', code: '/::Z', title: '睡', reg: /\/::Z/g },
        { file: '109.gif', code: '/::\'(', title: '哭', reg: /\/::'\(/g },
        { file: '110.gif', code: '/::-|', title: '囧', reg: /\/::-\|/g },
        { file: '111.gif', code: '/::@', title: '怒', reg: /\/::@/g },
        { file: '112.gif', code: '/::P', title: '调皮', reg: /\/::P/g },
        { file: '113.gif', code: '/::D', title: '笑', reg: /\/::D/g },
        { file: '114.gif', code: '/::O', title: '惊讶', reg: /\/::O/g },
        { file: '115.gif', code: '/::(', title: '难过', reg: /\/::\(/g },
        { file: '116.gif', code: '/::+', title: '酷', reg: /\/::\+/g },
        { file: '117.gif', code: '/:--b', title: '汗', reg: /\/:--b/g },
        { file: '118.gif', code: '/::Q', title: '抓狂', reg: /\/::Q/g },
        { file: '119.gif', code: '/::T', title: '吐', reg: /\/::T/g },
        { file: '120.gif', code: '/:,@P', title: '笑', reg: /\/:,@P/g },
        { file: '121.gif', code: '/:,@-D', title: '快乐', reg: /\/:,@-D/g },
        { file: '122.gif', code: '/::d', title: '奇', reg: /\/::d/g },
        { file: '123.gif', code: '/:,@o', title: '傲', reg: /\/:,@o/g },
        { file: '124.gif', code: '/::g', title: '饿', reg: /\/::g/g },
        { file: '125.gif', code: '/:|-)', title: '累', reg: /\/:\|-\)/g },
        { file: '126.gif', code: '/::!', title: '吓', reg: /\/::!/g },
        { file: '127.gif', code: '/::L', title: '汗', reg: /\/::L/g },
        { file: '128.gif', code: '/::>', title: '高兴', reg: /\/::>/g },
        { file: '129.gif', code: '/::,@', title: '闲', reg: /\/::,@/g },
        { file: '130.gif', code: '/:,@f', title: '努力', reg: /\/:,@f/g },
        { file: '131.gif', code: '/::-S', title: '骂', reg: /\/::-S/g },
        { file: '133.gif', code: '/:,@x', title: '秘密', reg: /\/:,@x/g },
        { file: '134.gif', code: '/:,@@', title: '乱', reg: /\/:,@@/g },
        { file: '135.gif', code: '/::8', title: '疯', reg: /\/::8/g },
        { file: '136.gif', code: '/:,@!', title: '哀', reg: /\/:,@!/g },
        { file: '137.gif', code: '/:!!!', title: '鬼', reg: /\/:!!!/g },
        { file: '138.gif', code: '/:xx', title: '打击', reg: /\/:xx/g },
        { file: '139.gif', code: '/:bye', title: 'bye', reg: /\/:bye/g },
        { file: '142.gif', code: '/:handclap', title: '鼓掌', reg: /\/:handclap/g },
        { file: '145.gif', code: '/:<@', title: '什么', reg: /\/:<@/g },
        { file: '147.gif', code: '/::-O', title: '累', reg: /\/::-O/g },
        { file: '153.gif', code: '/:@x', title: '吓', reg: /\/:@x/g },
        { file: '155.gif', code: '/:pd', title: '刀', reg: /\/:pd/g },
        { file: '156.gif', code: '/:<W>', title: '水果', reg: /\/:<W>/g },
        { file: '157.gif', code: '/:beer', title: '酒', reg: /\/:beer/g },
        { file: '158.gif', code: '/:basketb', title: '篮球', reg: /\/:basketb/g },
        { file: '159.gif', code: '/:oo', title: '乒乓', reg: /\/:oo/g },
        { file: '195.gif', code: '/:circle', title: '跳舞', reg: /\/:circle/g },
        { file: '160.gif', code: '/:coffee', title: '咖啡', reg: /\/:coffee/g }
      ],
      send_content: '',
      frequency: 0,
      warn: false,
      showEmoji: false,
      // 自定义回复
      replyList: [
        '简单点, 说话的方式简单点, 递进的情绪请省略, 你又不是个演员, 别设计那些情节.',
        '1',
        '收到了',
        '请说清楚点',
        '哈哈, 我明白你意思了'
      ],
      curReplyIndex: 0,
      timer: null,
      selfInfo: {},
      loading: true
    }
  },
  computed: {
  },
  watch: {
    orderCode() {
      var that = this
      that.$nextTick(() => {
        that.initData()
      })
    }
  },
  mounted() {
    var that = this
    that.$nextTick(() => {
      that.initData()
    })
  },
  created() {
    var that = this
    that.selfInfo = that.$AppHelper.getUserInfo()
    // console.log('usercode', that.selfInfo.usercode);
  },
  destroyed() {
    var that = this
    if (that.timer) {
      window.clearTimeout(that.timer)
    }
  },
  methods: {
    initData() {
      var that = this

      that.chatDataList = []
      // 在页面加载时让信息滚动到最下面
      that.$nextTick(() => {
        that.getList()
      })
    },
    replaceFace(con) {
      if (con.includes('/:')) {
        var emojis = this.emojis
        for (var i = 0; i < emojis.length; i++) {
          con = con.replace(emojis[i].reg, '<img src="/res/emoji/' + emojis[i].file + '"  alt="" style="vertical-align: middle; width: 24px; height: 24px" />')
        }
        return con
      }
      return con
    },
    // 按回车发送信息
    onKeyup(e) {
      var that = this
      if (e.keyCode !== 13) {
        return
      }
      if (that.send_content.length <= 1) {
        that.send_content = ''
        // that.warn = true
        // setTimeout(() => {
        //   that.warn = false
        // }, 1000)
        that.$toast.warning('不能发送空白信息');
        return
      }
      that.sendMsg()
    },
    sendMsg() {
      var that = this
      if (that.send_content.length <= 0) {
        that.send_content = ''
        // that.warn = true
        // setTimeout(() => {
        //   that.warn = false
        // }, 1000)
        that.$toast.warning('不能发送空白信息');
      } else {
        that.$api.bz.sendGzDynamicMsg({ order_code: that.orderCode, content: that.send_content, from_user: '001' }).then(res => {
          // console.log('result', res)
          if (!res.success) {
            that.$toast.warning(res.error_msg ? res.error_msg : '发送失败');
            return
          }
          that.send_content = ''
        })
        // that.scrollFooter()
      }
    },
    clickPage() {
      var that = this
      that.showEmoji = false
    },
    // 滚动到底部 (这里没有滚动，让外部去滚动)
    scrollFooter() {
      // return
      var that = this
      // setTimeout(() => { that.$refs.us_el_bar.$refs.wrap.scrollTop = that.$refs.us_el_bar.$refs.wrap.scrollHeight }, 0)
      that.$emit('scroll-footer')
    },
    dateFormat(time) {
      var that = this
      var text = that.$moment(time).fromNow()
      return text
    },
    getReply() {
      var that = this
      if (that.curReplyIndex === 5) {
        that.curReplyIndex = 0
      }
      that.curReplyIndex++
      return that.replyList[that.curReplyIndex - 1]
    },
    addOpContent(text) {
      var that = this
      var oplog = {
        m_type: 'op_log',
        date: now,
        content: text,
        from_user: {
          name: 'cavaler',
          img: 'http://n.sinaimg.cn/front/480/w640h640/20181029/Eyfh-hnaivxq1128066.jpg'
        }
      }
      that.chatDataList.messages.push(oplog)
      that.scrollFooter()
    },
    // 获取最近几条动态
    async getList() {
      var that = this

      if (!that.orderCode) {
        return
      }
      var res = await that.$api.bz.getGzDynamicList({ order_code: that.orderCode })
      if (!res.success) {
        // that.$toast.warning('获取动态失败.');
        console.log('获取报障动态列表失败', res);
        return
      }
      // console.log('getGzDynamicList.res', res);
      that.chatDataList = res.data

      for (let index = 0; index < that.chatDataList.length; index++) {
        var item = that.chatDataList[index]
        var fromUser = item.from_user
        if (!fromUser) {
          item.from_user = that.self
        } else {
          var from_user = {
            name: fromUser.USER_NAME ? fromUser.USER_NAME : fromUser.NICK_NAME,
            img: fromUser.HEAD_IMAGE_URL
          }
          item.from_user = from_user
        }
      }

      that.loading = false

      that.getDynamicTimer()
      // that.scrollFooter()
    },
    // 获取最新动态
    async getLastDynamic() {
      var that = this
      var curDyid = 0
      if (that.chatDataList.length > 0) {
        var ld = that.chatDataList[that.chatDataList.length - 1]
        curDyid = ld.GZ_DYNAMIC_RECORD_ID
      }
      var res = await that.$api.bz.getGzDynamicLast({ order_code: that.orderCode, cur_dyid: curDyid })
      if (!res.success) {
        // that.$toast.warning('获取动态失败.');
        console.log('获取最近报障动态失败', res);
        return
      }
      var data = res.data
      if (!data || data.length === 0) {
        return
      }
      var hasOplog = false
      for (let index = 0; index < data.length; index++) {
        var item = data[index]
        // if (item.DR_USER_CODE !== '001') {
        //   item.from_user = {
        //     name: 'bull',
        //     img: 'http://n.sinaimg.cn/front/480/w640h640/20181029/Eyfh-hnaivxq1128066.jpg'
        //   }
        // } else {
        //   item.from_user = that.self
        // }
        var fromUser = item.from_user
        if (!fromUser) {
          item.from_user = that.self
        } else {
          var from_user = {
            name: fromUser.USER_NAME ? fromUser.USER_NAME : fromUser.NICK_NAME,
            img: fromUser.HEAD_IMAGE_URL
          }
          item.from_user = from_user
        }
        that.chatDataList.push(item)
        if (item.DR_TYPE === 1) {
          hasOplog = true
          continue
        }
        that.scrollFooter()
      }
      if (hasOplog) {
        that.$emit('has-new-op')
      }
    },
    //
    getDynamicTimer() {
      var that = this
      that.getLastDynamic()
      if (that.timer) {
        window.clearTimeout(that.timer)
      }
      that.timer = setTimeout(that.getDynamicTimer, 2 * 1000)
    },
    getMsgTimeFormat(time) {
      var that = this
      // var dura = that.$momentUtil.getDuraMinutes(time)
      // console.log('time', time)
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY年MM月DD日 HH:mm')
      }
      return mt.format('HH:mm')
    },
    startsWith(value, str) {
      var length = str.length
      // if (!length) {
      //   if (value.startsWith(str)) {
      //     return true
      //   } else {
      //     return false
      //   }
      // }
      var str1 = value.substr(0, length)
      if (str === str1) {
        return true
      }
      return false
    },
    // 是否要显示日期时间, 如果一样就不显示.
    showTime(item, index) {
      return true
      // var that = this
      // if (index === 0) {
      //   return true
      // }
      // var prev = that.chatDataList[index - 1]
      // return that.getMsgTimeFormat(prev.DR_TIME) !== that.getMsgTimeFormat(item.DR_TIME)
    }
  }
}
</script>

<style scoped>
 .us-chat-msg{
     /* background-image: url("~@/assets/res/20052801.jpg"); */
    border: 1px solid #f5f5f5;
 }

.emojiBox li{
    list-style-type:none;
}

 .us-el-dialog /deep/ .el-dialog__body {
  padding: 0px;
}

.us-el-dialog /deep/ .el-dialog__header{
  padding: 0px;
}

.us-el-dialog /deep/ .el-dialog__headerbtn {
  font-size: 30px;
  top:8px;
}

.us-chat-msg >>> .el-scrollbar__wrap {
  overflow-x: auto;
}

.us-op-content{
  margin-left: 15px;
  margin-right: 17px;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  color: #000;
  border-radius: 3px;
  background-color: #fff;
  padding: 10px;
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,0.07); */
}

.us-msg-item{
  margin: 2px 3px;
  padding-bottom: 8px;
}

.us-op-content:hover{
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,0.12); */
}

</style>

<style scoped>

    .header{
        height: 60px;
        padding: 28px 0 0 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #f5f5f5;
    }

    .friendname{
        font-size: 18px;
    }

    .message-wrapper{
        min-height: 205px;
        /* height: 205px; */
        /* max-height: 205px; */
        /* padding: 10px 15px; */
        box-sizing: border-box;
        overflow-y:hidden;
        background: #f5f5f5;
        border-bottom: 1px solid #f5f5f5;
    }

    .time{
        width: 100%;
        font-size: 12px;
        margin: 7px auto;
        margin-bottom: 2px;
        text-align: center;
    }

    .time span{
        display: inline-block;
        padding: 4px 6px;
        color: #fff;
        border-radius: 3px;
        background-color: #dcdcdc;
    }

    .main .avatar{
        float: left;
        margin-left: 15px;
        border-radius: 3px;
        margin-top:7px;
    }

    .main .content{
        display: inline-block;
        margin-left: 10px;
        position: relative;
        padding: 6px 10px;
        max-width: 250px;
        min-height: 36px;
        line-height: 24px;
        box-sizing: border-box;
        font-size: 14px;
        text-align: left;
        word-break: break-all;
        border-radius: 4px;
        background-color: #FFF;
        color: #000;
    }

    .main .content:before{
        content: " ";
        position: absolute;
        top: 12px;
        right: 100%;
        border: 6px solid transparent;
        border-right-color: #FFF;
    }

    .self{
        text-align: right;
    }

    .self .avatar{
        float: right;
        margin:0 15px;
    }

    .self .content{
        background-color: #9EEA6A;
    }

    .self .content:before {
        right: -12px;
        vertical-align: middle;
        border-right-color: transparent;
        border-left-color: #9EEA6A;
    }

    .message-wrapper ul{
        list-style:none;
        margin:0px;
        padding-left: 0;
    }

</style>

<style scoped>
 .chat-footer{
    position: relative;
    /* height: 142px; */
    background: #fff;
 }
 .chat-footer .emoji{
    /* position: relative; */
    width: 100%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    padding: 0 15px;
    box-sizing: border-box;
    color: #7c7c7c;
 }
 .chat-footer .emoji .icon-look{
    cursor: pointer;
    font-size: 20px;
 }
 .chat-footer .emoji .icon-look:hover{
    color: #1aad19;
 }
 .chat-footer .emoji .emojiBox{
    position: absolute;
    display: flex;
    flex-wrap: wrap;
    top: -210px;
    left: 0px;
    width: 300px;
    height: 200px;
    padding: 5px;
    background-color: #fff;
    border: 1px solid #d1d1d1;
    border-radius: 2px;
    box-shadow:0 1px 2px 1px #d1d1d1;
 }

 .chat-footer textarea{
    box-sizing: border-box;
    padding: 0 15px;
    /* height: 55px; */
    width: 100%;
    border: none;
    outline: none;
    font-family: "Micrsofot Yahei";
    resize: none;
    font-size: 14px;
 }

 .chat-footer .v-textarea{
    box-sizing: border-box;
    padding: 0 15px;
    /* height: 55px; */
    width: 100%;
    border: none;
    outline: none;
    font-family: "Micrsofot Yahei";
    resize: none;
    font-size: 14px;
 }

 .chat-footer .send{
    /* position: absolute;
    bottom: 10px;
    right: 30px; */
    /* width: 75px; */
    /* height: 28px; */
    /* line-height: 28px; */
    box-sizing: border-box;
    /* text-align: center; */
    /* border: 1px solid #e5e5e5; */
    border-radius: 3px;
    /* background: #f5f5f5; */
    font-size: 14px;
    color: #7c7c7c;
    cursor: pointer;
 }

 /* .chat-footer .send:hover{
    background: rgb(18,150,17);
    color: #fff;
 } */

 .chat-footer .warn{
    position: absolute;
    bottom: 56px;
    right: 10px;
    width: 110px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    text-align: center;
    border: 1px solid #bdbdbd;
    border-radius: 4px;
    background-color: #fff;
    box-shadow:0 1px 5px 1px #bdbdbd;
 }

 .chat-footer .warn::before{
    content: " ";
    position: absolute;
    top: 100%;
    right: 20px;
    border: 7px solid transparent;
    border-top-color: #fff;
    filter:drop-shadow(1px 3px 2px #bdbdbd);
 }

</style>
